'use strict';

import RowEditView from 'commons/views/RowEdit.js';
import template from '../../templates/managers/Account.ejs';
import Companies from 'collections/Companies.js';

module.exports = RowEditView.extend({
    tagName: 'tr',

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            template: template,
            deletable: false,
            companies: new Companies()
        });
        this.options.templateExtra = {
            companies: this.options.companies
        };

        return RowEditView.prototype.initialize.apply(this, arguments);
    },

    render: function() {
        let r = RowEditView.prototype.render.apply(this, arguments);
        this.$('.chosen-select').chosen({width: '100%'});
        return r;
    }
});



// WEBPACK FOOTER //
// ./app/mpp/views/managers/Account.js